/*eslint-disable array-callback-return */
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
import MasterPermissions from 'src/Admin/api/MasterPermissions';
export const CoverageTypeFilter = ({
  options,
  onChange,
  selectedCoverage,
  value,
}) => {
  return (
    <AutoSuggestionSelectComponent
      options={options}
      components={{ IndicatorSeparator: () => null }}
      inputClassName="coverage-type-filter height-32 view-member"
      //value={{ label: activeCoverageType, value: activeCoverageType }}
      value={value}
      onChange={(e) => {
        onChange(e);
      }}
      isSearchable={false}
    />
  );
};
